
export interface TransactionData {
    id: string;
    paymentMode: string;
    amount: string;
    networkTransactionId: string | null;
    transactionStatus: string;
    createdTime: string;
    created: string;
    transactionTime: string ;
    rawError: string | null;
    targetWallet: string | null;
    failed: boolean;
    // the payout's latest reward day, from the server; it used to be read off the first nested reward row
    hashRateInTh: number;
    username: string;
    dummy: boolean;
    customerGroupName: string | null;
    // amount per reward source (SEGPOOL, SEGPROXY); null for transactions created before sources were tracked
    sources: Record<string, number> | null;
    // email: string;
}

export interface CustomerGroups {
    baseWorker: string;
    customerGroupName: string
}



function toTransactionData(x: any): TransactionData {
    return {
        id: x.id,
        dummy: x.dummy,
        paymentMode: x.paymentMode,
        amount: x.amount.toString(),
        networkTransactionId: x.networkTransactionId,
        transactionStatus: x.transactionStatus,
        createdTime: x.createdTime,
        created: dateStyled(x.createdTime),
        transactionTime: x.transactionTime,
        rawError: x.rawError,
        targetWallet: x.targetWallet ?? null,
        failed: x.failed,
        hashRateInTh: x.hashRateInTh ?? 0,
        username: x.username ?? "",
        customerGroupName: x.customerGroupName,
        sources: x.sources ?? null
    };
}


export function processTransactionList(data: any[]): TransactionData[] {
    return data.map(toTransactionData);
}

function dateStyled(createdTime: any): string {
    if (createdTime == null || createdTime == undefined) return "";
    let date = new Date(createdTime);
    return String(date.getDate()).padStart(2, '0') + "/" + String(date.getMonth() + 1).padStart(2, '0') + "/" + date.getFullYear();
}

export interface BalanceData {
    [coin: string]: {
        available: number;
        pending: number;
        total: number;
    };
}
